import { provideComponent } from "scrivito"
import { ScrivitoLink } from "scrivito/scrivito-link/ScrivitoLink"
import { useNeoletterUserProfile } from "shared/api/neoletter-user-profile/useNeoletterUserProfile"
import { useAuth } from "shared/lib/useAuth"

import { UserDetails } from "widgets/user-details/UserDetails"

import { UserDetailsWidget } from "./UserDetailsWidgetClass"

provideComponent(UserDetailsWidget, ({ widget }) => {
  const { userProfile, loading } = useNeoletterUserProfile()
  const { userInfo } = useAuth()
  const link = widget.get("link")

  if (link) {
    return (
      <ScrivitoLink className="link" to={link}>
        <UserDetails userInfo={userProfile || userInfo} isLoading={loading} />
      </ScrivitoLink>
    )
  }

  return <UserDetails userInfo={userProfile || userInfo} isLoading={loading} />
})
